import { cn } from '@/lib/utils';
import { FC, ReactNode } from 'react';
import { InputContainer } from '../InputContainer';
import { InputProps, withField } from '../withField';
import { countDigits } from './helpers/number';

export interface TextInputProps {
  placeholder?: string;

  suffix?: string | ReactNode;
  prefix?: string | ReactNode;
  allowNegatives?: boolean;
  onlyDigits?: boolean;
  maxDigitLength?: number;
}

export const TextInput: FC<InputProps<string> & TextInputProps> = ({
  onChange,
  value,
  id,
  placeholder,
  suffix,
  prefix,
  onlyDigits,
  readonly,
  className,
  autofocus,
  allowNegatives,
  maxDigitLength
}) => {
  return (
    <InputContainer className={cn('px-3 py-2', className)}>
      {prefix && <span className="text-secondary-std mr-0.5 text-sm">{prefix}</span>}
      <input
        autoFocus={autofocus}
        readOnly={readonly}
        value={value ?? ''}
        onChange={e => {
          let newValue = e.target.value;

          if (onlyDigits) {
            newValue = newValue.replace(/(?!^-)[^\d.]+/g, '').replace(/(\..*)\./g, '$1');

            if (!allowNegatives) {
              newValue = newValue.replace(/-/g, '');
            }

            if (maxDigitLength && countDigits(newValue) > maxDigitLength) return;
          }

          onChange(newValue);
        }}
        type="text"
        id={id}
        className="placeholder:text-secondary-std placeholder:italic block flex-1 border-0 bg-transparent p-0 text-sm placeholder:opacity-60 focus:ring-0 sm:leading-6"
        placeholder={placeholder}
      />
      {suffix && <span className="text-secondary-std ml-0.5 text-sm">{suffix}</span>}
    </InputContainer>
  );
};

export const TextField = withField<string, TextInputProps>(TextInput);
